//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from '../../src/common/helpers/HttpHelper';
import environments from '../../src/common/environments/environment';
const http = new httpHelper();

export const AddManageGAActions = {
    GetAddManageGAJSON: getAddManageGAJSON,
    CreateGAJSON: createGAJSON,
    AccDetailsJSON: accDetailsJSON,
    GetFeaturesList: getFeaturesList,
    SaveFeaturesList: saveFeaturesList
}

function getAddManageGAJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.ADD_MANAGE_GA_JSON);
}

function createGAJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.CREATE_GA_JSON);
}

function accDetailsJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.ACC_DETAILS_JSON);
}

function getFeaturesList(ProgramClassId, countryCode) {
    let refGetFeaturesList = environments.FEATURES_BASED_ON_PROGRAM_CLASS_ID + "?ProgramClassId=" + ProgramClassId + "&CountryCode=" + countryCode
    return http.adminGet(refGetFeaturesList);
}

function saveFeaturesList(id, payload) {
    let refSaveFeaturesList = environments.SAVE_FEATURES_IN_GA.replace("{programSetupId}", id)
    return http.adminPut(refSaveFeaturesList, payload);
}
